export const trimSlashes = (path) => path?.replace(/[\/]+$/, "");
